import { ChatExpirationEvents } from "constants/ChatStatusConstants";
import { Subject } from "rxjs";

const ChatExpirationSubject = new Subject();

const ChatExpirationService = {
  listen: () => ChatExpirationSubject.asObservable(),
  startWaitingForClientReply: (conversation) =>
    ChatExpirationSubject.next({
      event: ChatExpirationEvents.START_WAITING,
      conversation,
    }),
  freezeConversation: (conversation) =>
    ChatExpirationSubject.next({
      event: ChatExpirationEvents.FREEZE,
      conversation,
    }),
  cancelWaitingForClientReply: (conversation) =>
    ChatExpirationSubject.next({
      event: ChatExpirationEvents.CANCEL_WAITING,
      conversation,
    }),
  messagesForChatLoaded: (conversation) =>
    ChatExpirationSubject.next({
      event: ChatExpirationEvents.MSGS_LOADED,
      conversation
    })
};

export default ChatExpirationService;
